<template>
    <div>
      <span id="landing_title_app_name" :class="$tt('headline1')">Changelog</span>
      <p :class="$tt('button')">See what's added and fixed</p>
      <ui-linear-progress :indeterminate="(!markdownContent || 0 === markdownContent.length)"/>
      <VueShowdown :markdown="markdownContent"/>
    </div>
</template>

<script>
import VueShowdown from 'vue-showdown'
import Vue from 'vue'

// the second parameter of Vue.use() is optional
Vue.use(VueShowdown, {
  // set default flavor of showdown
  flavor: 'github'
})

export default {
  name: 'changelog',
  components: {
  },
  methods: {

  },
  mounted () {
    let _this = this
    window.jQuery.get({
      url: 'https://raw.githubusercontent.com/SkylineLWP/Changelog/master/README.md',
      cache: false
    }).then(function (markdownText) {
      _this.markdownContent = markdownText
    })
  },
  data () {
    return {
      markdownContent: ''
    }
  }
}
</script>

<style scoped>

</style>
